export const setImageData = (
    image: File, service, sendErrorSizeImage, sendAddError,
    sendAddImage, setImage, setDimension, setError, dispatch
) => {

    dispatch(setError(''));
    const imageElement: any = document.createElement('img');

    imageElement.onload = function () {
        loadImage(
            image, imageElement, service, setError, sendErrorSizeImage,
            sendAddError, sendAddImage, setImage, setDimension, dispatch
        )
    };

    imageElement.src = URL.createObjectURL(image);
};

export const fileToBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
});


export const blobToBase64 = blob => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    return new Promise(resolve => {
      reader.onloadend = () => {
        resolve(reader.result);
      };
    });
  };


export const loadImage = (
    image, imageElement, service, setError, sendErrorSizeImage,
    sendAddError, sendAddImage, setImage, setDimension, dispatch
) => {
    const width = imageElement.naturalWidth;
    const height = imageElement.naturalHeight;

    if (width > 12000 || height > 12000) {
        dispatch(setError('notSizeValid'));

        if (service === 'rotator' || service === 'flipper') {
            sendErrorSizeImage();
        } else {
            sendAddError('not_size_valid');
        }

    } else {
        sendAddImage(image.type, width, height);

        const imageAction = setImage(image);
        const dimensionAction = setDimension(height, width)

        dispatch(imageAction.setImage);
        dispatch(imageAction.setName);
        dispatch(imageAction.setFormat);
        dispatch(dimensionAction.image);
        dispatch(dimensionAction.canvas);
    }
}

export const getBorderCrop = (cropWidth: number, cropHeight: number, isBigger: boolean): number => {
    const borderProcents = 0.01;

    if (isBigger) return cropWidth * borderProcents > cropHeight * borderProcents ? cropWidth * borderProcents : cropHeight * borderProcents;

    return cropWidth * borderProcents < cropHeight * borderProcents ? cropWidth * borderProcents : cropHeight * borderProcents;
}

export const checkPositionMouse = (positionX: number, positionY: number, canvasWidth: number, canvasHeight: number, mousePositionX, mousePositionY, borderWidth: number) => {
    return {
        isTopResize:
            (positionX - borderWidth <= mousePositionX
                && mousePositionX <= positionX + borderWidth + canvasWidth)
            && (mousePositionY >= positionY - borderWidth
                && mousePositionY <= positionY + borderWidth),
        isRightResize:
            (positionX + canvasWidth - borderWidth <= mousePositionX
                && mousePositionX <= positionX + canvasWidth + borderWidth)
            && (mousePositionY >= positionY - borderWidth
                && mousePositionY <= positionY + canvasHeight + borderWidth),
        isBottomResize:
            (positionX - borderWidth <= mousePositionX && mousePositionX <= positionX + borderWidth + canvasWidth)
            && (mousePositionY >= positionY + canvasHeight - borderWidth
                && mousePositionY <= positionY + canvasHeight + borderWidth),
        isLeftResize: (positionX - borderWidth <= mousePositionX
            && mousePositionX <= positionX + borderWidth)
            && (mousePositionY >= positionY - borderWidth
                && mousePositionY <= positionY + canvasHeight + borderWidth),
        inCrop: mousePositionX >= positionX + borderWidth
            && mousePositionX <= positionX + canvasWidth - borderWidth
            && mousePositionY >= positionY + borderWidth
            && mousePositionY <= positionY + canvasHeight - borderWidth
    }
}